import { Injectable } from '@angular/core';
import { Observable, from } from 'rxjs';
import { ExactAlarmPermissionWrapper } from 'src/app/wrappers/exact-alarm-permission.wrapper';

@Injectable({
  providedIn: 'root'
})
export class ExactAlarmPermissionAdapter {
  constructor(private wrapper: ExactAlarmPermissionWrapper) {}

  requestPermission(): Observable<boolean> {
    const requestPromise = this.wrapper
      .requestPermission()
      .then((response) => response.granted);
    const observable = from(requestPromise);

    return observable;
  }

  hasPermission(): Observable<boolean> {
    const hasPermissionPromise = this.wrapper
      .hasPermission()
      .then((response) => response.hasPermission);
    const observable = from(hasPermissionPromise);

    return observable;
  }
}
